export default __webpack_public_path__ + "static/media/figuremap28.5dba1dd6.png";